module.exports = __webpack_public_path__ + "assets/img/img-seo-none.9b4eb019.png";